module.exports = __webpack_public_path__ + "static/img/negative.c1c4a04.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/negative.gif
// module id = NK4y
// module chunks = 1